<template>
  <div v-if="data.registro"
       role="tablist">
    <b-card no-body
            class="cardInfo"
            @submit.prevent="cardChanged(clickRegistro, 'clickRegistro')">
      <button v-b-toggle.dados_collapse
              block
              class="cardInfoBtn"
              type="submit"
              @click="cardChanged(clickRegistro, 'clickRegistro')">
        Registro {{ data.registro.registro_id ? '' : '- Não informado' }}
        <span v-if="!clickRegistro">
          <icon-svg class="icons--black icon--xxs"
                    icon="arrowRight" />
        </span>
        <span v-else>
          <icon-svg class="icons--black icon--xxs"
                    icon="arrowDown" />
        </span>
      </button>
    
      <b-collapse v-if="clickRegistro"
                  id="dados_collapse">
        <div class="mt-3 pl-3 pr-3 pb-2">
          <div class="row">
            <div class="col-2 col-sm-3">
              <label class="resumo-show_label"
                     for="">Nome do Digitador</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.digitador || 'Não informado' }}
              </div>
            </div>
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Escrevente</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.escrevente || 'Não informado' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for="">Data do Registro</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.data_registro | date }}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Acervo</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.livro ? data.registro.livro.acervo : 'Não informado' }}
              </div>
            </div>
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Livro</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.livro ? data.registro.livro.num_livro : 'Não informado' }}
              </div>
            </div>
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Folha</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.folha || 'Não informado' }}
              </div>
            </div>
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Registro</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.termo || 'Não informado' }}
              </div>
            </div>
            <div class="col-2">
              <label class="resumo-show_label"
                     for="">Lado</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.lado || 'Não informado' }}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <label class="resumo-show_label"
                     for="">Matrícula</label>
              <div class="resumo-show_sublabel">
                {{ data.registro.matricula || 'Não informado' }}
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <!-- <transporte-collapse v-if="!!data.registro.transporte"
                         :prop-data="data.registro.transporte" /> -->
  </div>
</template>

<script>
  import TransporteCollapse from "@/components/SofiaRei/Resumo/Collapses/TransporteCollapse"

  export default {
    name: "Fourth",
    components: {
      TransporteCollapse 
    },
    props: ["data"],
    data () {
      return {
        clickRegistro: false
      }
    },
    methods: {
      cardChanged (val, name) {
        this[name] = !val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cardInfo {
    padding-top: 15px;
    border-radius: 0;
    border: 0 solid;
  }

  .cardInfoBtn {
    border-radius: 0;
    border: 0 solid;
    background-color: #eaeaea;
    color: #000;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    padding: 10px;
    padding-left: 19px;
    margin-bottom: 1px;
  }

  .cardInfoBtn:active,
  .cardInfoBtn:hover {
    outline: 0 !important;
  }
</style>
